var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-sm m-l-lg m-b-sm",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.chartOpen()
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.isOpen ? "Close" : "Open") + "\n  ")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "m-l-lg lead" }, [
        _vm._v(" " + _vm._s(_vm.chartName) + " "),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "expand" } }, [
        _vm.isOpen
          ? _c(
              "div",
              [
                _c("apexchart", {
                  attrs: {
                    type: "scatter",
                    height: this.height,
                    options: this.chartOptions,
                    series: this.series,
                  },
                }),
                _vm._v(" "),
                _vm.showBrush
                  ? _c("apexchart", {
                      attrs: {
                        type: "scatter",
                        height: this.height / 2,
                        options: this.brushOptions,
                        series: this.seriesBrush,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }